import { render, staticRenderFns } from "./PlayerTechnologyReceived.vue?vue&type=template&id=2ded9355&scoped=true&"
import script from "./PlayerTechnologyReceived.vue?vue&type=script&lang=js&"
export * from "./PlayerTechnologyReceived.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ded9355",
  null
  
)

export default component.exports